export const TRANSLATION_NAMESPACE = 'jbp-ram-manager-assignment'

export const TRANSLATION_KEYS = {
  welcome: {
    title: `${TRANSLATION_NAMESPACE}_welcome-title`,
    notRoles: `${TRANSLATION_NAMESPACE}_welcome-not-roles`,
    description: `${TRANSLATION_NAMESPACE}_welcome-description`,
    descriptionHasRoles: `${TRANSLATION_NAMESPACE}_welcome-description-has-roles`,
  },

  addNewContact: `${TRANSLATION_NAMESPACE}_add-new-contact`,
  addNewContactTooltip: `${TRANSLATION_NAMESPACE}_add-new-contact-tooltip`,
  deleteTooltip: `${TRANSLATION_NAMESPACE}_delete-sales-team-tooltip`,
  deleteTicketTooltip: `${TRANSLATION_NAMESPACE}_delete-ticket-tooltip`,
  changeTooltip: `${TRANSLATION_NAMESPACE}_change-tooltip`,
  acknowledge: {
    included: `${TRANSLATION_NAMESPACE}_acknowledge-included`,
    optional: `${TRANSLATION_NAMESPACE}_acknowledge-optional`,
    excluded: `${TRANSLATION_NAMESPACE}_acknowledge-excluded`,
  },

  columns: {
    role: `${TRANSLATION_NAMESPACE}_column-role`,
    contact: `${TRANSLATION_NAMESPACE}_column-contact`,
    bu: `${TRANSLATION_NAMESPACE}_column-bu`,
    includeInAcknowledge: `${TRANSLATION_NAMESPACE}_column-include-in-acknowledge`,
    actions: `${TRANSLATION_NAMESPACE}_column-actions`,
    leadPbm: `${TRANSLATION_NAMESPACE}__column_lead-pbm`,
  },
}
